/**
 * Lib.Common: Telemetry
 */


import telemetry from '../components/private/telemetry';

export default {
    telemetry
};
